'use client';

import { RosterCardData } from '@wwe-portal/ui/features/roster/roster-card/roster-card-v2';
import {
  RosterTrendingCarousel,
  RosterTrendingCarouselSkeleton,
} from '@wwe-portal/ui/features/roster/roster-trending-carousel';
import {
  useGetMySuperstarMap,
  useTrendingSuperstars,
} from '@wwe-portal/web/providers/queries/superstar-v2';
import { useIsAuthenticated } from '@wwe-portal/web/providers/stores/auth-store';
import {
  fullStar,
  mapPlayerRosterToTrendingCardData,
} from '@wwe-portal/web/utils/superstar-details/mapper';
import Image from 'next/image';
import { SuperstarLink } from '../common/link/superstar-link';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';
import { sendTrendingSupersstarFlipButtonClickEvent } from '@wwe-portal/web/libs/analytics/superstars-v2';
import { useMemo } from 'react';

const SuperstarImage = ({
  superstar,
}: {
  superstar: Pick<RosterCardData, 'image' | 'title'>;
}) => {
  return (
    <Image
      width={196}
      height={257}
      src={superstar.image ?? ''}
      alt={superstar.title}
      className="object-contain"
    />
  );
};

export const SuperstarTrendings = () => {
  const isAuthenticated = useIsAuthenticated();
  const { data: responseData, isLoading } = useTrendingSuperstars();
  const { isHydrated } = useResponsive();
  const { superstarMap } = useGetMySuperstarMap();

  const data = useMemo(() => {
    return responseData?.data.map((item) => {
      return mapPlayerRosterToTrendingCardData(item, {
        mySuperstars: superstarMap,
        defaultStar: fullStar,
        isAuthenticated,
      });
    });
  }, [responseData, superstarMap, isAuthenticated]);

  if (isLoading || !isHydrated) return <RosterTrendingCarouselSkeleton />;

  return (
    <RosterTrendingCarousel
      data={data}
      imageRenderer={SuperstarImage}
      LinkComponent={SuperstarLink}
      onItemFlip={(playerRoster) => {
        if (!playerRoster.id) return;
        sendTrendingSupersstarFlipButtonClickEvent(
          playerRoster.id,
          'superstar_guide_trending'
        );
      }}
    />
  );
};
